export default __webpack_public_path__ + "static/media/subsurface_dam.367fabb5.png";